import { isNumber } from 'lodash-es'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({ jumpPath: state => state.global.jumpPath })
  },

  watch: {
    jumpPath ({ delay = 0, method = 'push', ...to }) {
      let func = () => this.$router[method](to)
      if (isNumber(to.path)) {
        func = () => this.$router.go(to.path)
      }
      setTimeout(func, delay)
    }
  }
}
